import currentTimeZone from '../config/timeZone';

/**
 * Function to convert 24hr time to UTC based on a specific time zone
 * @param time - Time in 24-hour format (e.g., "14:30")
 * @returns - Date in UTC as a string in ISO format
 */
const ConvertToUTC = (time24hr: string, date?: string) => {
  if (time24hr === '' || time24hr === null) {
    return '';
  }

  // Parse the time input (in 24-hour format)
  const [hours, minutes] = time24hr.split(':').map(Number);

  // Check if the time format is valid
  if (Number.isNaN(hours) || Number.isNaN(minutes)) {
    return '';
  }

  // Create a Date object with the current date and the provided time
  let localDate = new Date();
  if (date) {
    localDate = new Date(date);
  }
  localDate.setHours(hours, minutes, 0, 0); // Set the time on the current date

  // Use toLocaleString to adjust the time for the current time zone
  const timeZoneDate = new Date(localDate.toLocaleString('en-US', { timeZone: currentTimeZone }));

  // Ensure the time is valid by checking getTime()
  if (Number.isNaN(timeZoneDate.getTime())) {
    return '';
  }

  // Convert the time to UTC and get the ISO string format
  const utcString = timeZoneDate.toISOString(); // Returns a string in the format "2024-11-28T17:30:00.000Z"

  return utcString;
};

export default ConvertToUTC;
